import { render, staticRenderFns } from "./OrderBid.vue?vue&type=template&id=dfa54816&scoped=true&"
import script from "./OrderBid.vue?vue&type=script&lang=js&"
export * from "./OrderBid.vue?vue&type=script&lang=js&"
import style0 from "./OrderBid.vue?vue&type=style&index=0&id=dfa54816&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa54816",
  null
  
)

export default component.exports